import { LessonBaseDto } from '@peartherapeutics/hylia-api-client';
import React from 'react';

import { BlockMiddleTable } from '../../Widgets/Blocks';
import { VerticalScrollbar } from '../../Widgets/CustomScrollbars';
import { CellHeader, Cell, Row, Heading } from '../../Widgets/TableComponents';

import styles from './styles.module.scss';

interface IProps {
  incompletedLessons: Pick<LessonBaseDto, 'name'>[];
}

const IncompletedLessons = (props: IProps) => {
  const { incompletedLessons } = props;

  return (
    <BlockMiddleTable testId="incompleted-lessons-block">
      <Heading>
        <Row>
          <CellHeader externalClasses={styles['heading-title']}>
            Title
          </CellHeader>
        </Row>
      </Heading>
      <VerticalScrollbar listLength={incompletedLessons.length}>
        {incompletedLessons.map((lesson, key) => (
          <Row key={`${lesson.name || ''}`}>
            <Cell titleKey={key} externalClasses={styles['cell-title']}>
              {lesson.name}
            </Cell>
          </Row>
        ))}
      </VerticalScrollbar>
    </BlockMiddleTable>
  );
};

export default IncompletedLessons;
